import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';
import AppProductCartButtonMain from "./app.product_cart_button.main";
import {BrowserRouter, Route} from "react-router-dom";
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from, ApolloLink} from "@apollo/client";
import {onError} from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import AppAuthLoginFormModal from "./auth/app.auth.loginform.modal";
import {cancelLastRequest} from "./auth/app.auth.actions";
import {AuthProvider} from "./auth/app.auth.context";
import Cookies from "js-cookie";
import {clientPrivate} from "../config/apollo_client";
import AppAuthModalPopup from "./auth/app.auth.modalpopup"
let hdr = {};
//let showAuth = null;


const AppProductCartButton = (
    <ApolloProvider client={clientPrivate}>
        <AuthProvider>
            <BrowserRouter>
                <AppProductCartButtonMain/>
            </BrowserRouter>
        </AuthProvider>
    </ApolloProvider>)
;



const el = document.getElementById('product_cart_button');
if(el){
    const root = createRoot(el);
    root.render(AppProductCartButton);
}
